import { render, staticRenderFns } from "./ProfileTalentSocialMedia.vue?vue&type=template&id=2607cc65"
import script from "./ProfileTalentSocialMedia.vue?vue&type=script&lang=js"
export * from "./ProfileTalentSocialMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports